import { Component, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseFormFieldComponent } from "../base-form-field.component";

@Component({
  selector: "rc-string-form-field",
  templateUrl: "./string-form-field.component.html",
  styleUrls: ["./string-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: StringFormFieldComponent,
    },
  ],
  standalone: false,
})
export class StringFormFieldComponent extends BaseFormFieldComponent<string | number> {
  @Input() errorText: string | undefined;

  public constructor() {
    super();
  }

  public async onInputChange(event: unknown) {
    const ionEvent = event as CustomEvent;

    const inputValue = ionEvent.detail.value;
    const allowedTypes = ["ionChange", "ionInput"];
    if (allowedTypes.includes(ionEvent.type) && this.readOnlyValue === inputValue) {
      return;
    }

    await this.onInputChangeInternal(inputValue);
  }

  protected toDisplayValue(input: string | number): string {
    return input?.toString();
  }
}
